<template>
<!-- 个人中心 -->
  <div class="wrapper">
    <header-nav :index_num="index_num"></header-nav>
    <div id="box">
      <!-- v-for="(list,index) in text" :key="index" -->
      <!-- {{list}} -->
      <div class="left" :style="{height:heightVal+'px'}">
        <div class="list" @click="btn(0)"  v-show="reg_show" :class="sub == 0 ? 'color' : ''">党组织申请</div>
        <div class="list" @click="btn(1)" :class="sub == 1 ? 'color' : ''">我的收藏</div>
        <div class="list" @click="btn(2)"  v-show="reg_show" :class="sub == 2 ? 'color' : ''">征集类项目</div>
        <div class="list" @click="btn(3)"  v-show="reg_show" :class="sub == 3 ? 'color' : ''">非征集类项目</div>
        <div class="list" @click="btn(4)"  :class="sub == 4 ? 'color' : ''">个人中心-修改密码</div>
        <div class="list" @click="btn(5)"   :class="sub == 5 ? 'color' : ''">留言板</div>
        <div class="list" @click="btn(6)" v-show="reg_show" :class="sub == 6 ? 'color' : ''">问题反馈</div>
      </div>
      <div class="right">
        <apply v-if="sub == 0" @listenToChildExen="showMsgFromChild" ></apply>
        <collection v-if="sub == 1" @listenToChildExen="showMsgFromChild"></collection>
        <declare v-if="sub == 2" @listenToChildExen="showMsgFromChild"></declare>
        <modify v-if="sub == 4" @listenToChildExen="showMsgFromChild"></modify>
        <collection1 v-if="sub == 5" @listenToChildExen="showMsgFromChild"></collection1>
        <feedbook v-if="sub == 6" @listenToChildExen="showMsgFromChild"></feedbook>
        <solicitation v-if="sub == 3" @listenToChildExen="showMsgFromChild"></solicitation>
      </div>
    </div>
    <footer-nav class="footer"></footer-nav>
  </div>
</template>

<script>
  import HeaderNav from "../../components/HeaderNav";
  import FooterNav from "../../components/FooterNav";
  import Apply from "./Apply";
  import Collection from "./Collection";
  import Collection1 from "./Collection1";
  import Feedbook from "./Feedbook";
  import Declare from "./Declare";
  import Modify from "./Modify";
  import Solicitation from "./Solicitation";
  export default {
    components: {
      HeaderNav,
      FooterNav,
      Apply,
      Collection,
      Collection1,
      Feedbook,
      Declare,
      Modify,
      Solicitation
    },
    props: {},
    data() {
      return {
        index_num: 3,
        text: [
          "党组织申请",
          "我的收藏",
          "项目申报",
          "非征集类型项目",
          "个人中心-修改密码",
          "@书记",
          "问题反馈"
        ],
        reg_show:true,
        sub: 0,
        heightVal: 1050
      };

    },
    methods: {
      showMsgFromChild(data) {
        this.heightVal = data;
      },
      btn(index) {
        if(sessionStorage.reg_type == 3){
          if(index == 2 || index == 3){
              this.$alert('个人用户不支持此模块！','提示',{
                confirmButtonText:"确定",
                callback:action => {}
              })
          }else{
              this.sub = index;
          }

        }else{
           this.sub = index;
        }

      },
      changeReg(){
        if(sessionStorage.reg_type == 3){
          this.reg_show = false;
          this.sub = 1;
        }else{
          this.reg_show = true
        }
      }
    },
    created(){
      this.changeReg()
    },
  };

</script>

<style lang='scss' scoped>
  .wrapper {
    min-width: 1280px;

    #box {
      width: 1200px;
      margin: 40px auto 0;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      align-items: flex-start;

      .left {
        width: 241px;
        background-color: #ffffff;
        box-shadow: 0px 7px 11px 0px rgba(231, 231, 231, 0.7);
        border-radius: 2px;
        .list {
          width: 100%;
          height: 48px;
          margin-top: 21px;
          text-align: left;
          line-height: 48px;
          padding-left: 37px;
          box-sizing: border-box;
          font-family: "MicrosoftYaHei";
          font-size: 20px;
          font-weight: normal;
          font-stretch: normal;
          letter-spacing: 0px;
          color: #333333;
          cursor: pointer;
        }

        .color {
          position: relative;
          color: #e60012;

          &::after {
            content: "";
            width: 5px;
            height: 48px;
            background-color: #e60012;
            border-radius: 8px;
            position: absolute;
            left: 0%;
            top: 0%;
          }
        }
      }

      .right {
        width: 934px;
        background-color: #ffffff;
      }
    }

    .footer {
      margin-top: 80px;
    }
  }

</style>
